import { canonicalManifestBytes } from "./canonicalManifest";
import { buildTarball } from "./tarball";
import { signPayload } from "./ed25519";

function bytesToB64(bytes: Uint8Array): string {
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin);
}

async function sha256(b: Uint8Array): Promise<Uint8Array> {
  return new Uint8Array(await crypto.subtle.digest("SHA-256", b as BufferSource));
}

export async function packageAndSign(args: {
  manifest: Record<string, unknown>;
  files: { path: string; bytes: Uint8Array }[];
  privateJwk: JsonWebKey;
}): Promise<{ tarballBytes: Uint8Array; signatureB64: string }> {
  const { manifest, files, privateJwk } = args;
  if (files.some((f) => f.path === "plugin.yaml")) {
    throw new Error("plugin.yaml is generated from the manifest; do not include it in files");
  }
  // Write the manifest as JSON text (a YAML subset yaml.safe_load parses identically).
  const manifestBytes = new TextEncoder().encode(JSON.stringify(manifest));
  const tarballBytes = buildTarball([{ path: "plugin.yaml", bytes: manifestBytes }, ...files]);
  const payload = new Uint8Array(64);
  payload.set(await sha256(tarballBytes), 0);
  payload.set(await sha256(canonicalManifestBytes(manifest)), 32);
  const sig = await signPayload(privateJwk, payload);
  return { tarballBytes, signatureB64: bytesToB64(sig) };
}
